import { render, staticRenderFns } from "./MultipleChoiceOneAnswer.vue?vue&type=template&id=53c9ae24&scoped=true&"
import script from "./MultipleChoiceOneAnswer.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceOneAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceOneAnswer.vue?vue&type=style&index=0&id=53c9ae24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9ae24",
  null
  
)

export default component.exports